import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("babiSolde_api");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des posters

export const listeDesPosters = async (page, size, param) => {
  // return await axios.get(`${BASE_URL}/parametres/allCategorie`), {});
  return await axios.get(
    `${BASE_URL}/parametrage/poster/all?page=${page}&size=${size}&param=${param}`,
    {}
  );
};
// Enregiste des posters

export const enregistrerPosters = async (poster) => {
  return await axios.post(`${BASE_URL}/parametrage/poster`, poster);
};

// modifie categorie

export const modifierPosterById = async (posterId, poster) => {
  return await axios.put(
    `${BASE_URL}/parametrage/poster/${posterId}`,
    poster
  );
};

// supprimer une categorie

export const supprimerUnePoster = async (posterId) => {
  return await axios.delete(`${BASE_URL}/parametrage/poster/${posterId}`);
};
